import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import PrivateRoute from './comps/PraviteRoute.jsx';
import NotFoundPage from './comps/notFound.jsx';
import { BrowserRouter, Route, Switch, useParams } from 'react-router-dom';
import Landing from './comps/landing.jsx';
import LoginForm from './comps/Login.jsx';
import Layout from './comps/Layout.jsx';
import MyDataPage from './comps/OrgChart.jsx';
import CreateFolder from './comps/createfolder.jsx';
import WorkspacePage from './comps/WorkSpace.jsx';
import AssemblyResultsPage from './comps/AssemblyResultsPage.jsx';
import BOMApprovalPage from './comps/BOMApprovalPage.jsx';
import SystemAdminDashboard from './comps/SystemAdminDashboard.jsx';
import UserAdminDashboard from './comps/UserAdminDashboard.jsx';
import TrainingDocs from './comps/TrainingDocs.jsx';

// Wrapper to force remount when assemblyId changes
function AssemblyResultsWrapper() {
  const { assemblyId } = useParams();
  return <AssemblyResultsPage key={assemblyId} />;
}

function BOMApprovalWrapper() {
  const { assemblyId } = useParams();
  return <BOMApprovalPage key={assemblyId} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Switch>
      {/* Public routes */}
      <Route path="/" exact component={Landing} />
      <Route path="/login" exact component={LoginForm} />

      {/* Private routes with sidebar layout */}
      <Layout>
        <Switch>
          <PrivateRoute exact path="/OrgChart" component={MyDataPage} />
          <PrivateRoute path="/createfolder" component={CreateFolder} />
          <PrivateRoute path="/workspace" component={WorkspacePage} />
          <PrivateRoute path="/system-admin" component={SystemAdminDashboard} allowedRoles={['SystemAdmin']} />
          <PrivateRoute path="/admin/dashboard" component={UserAdminDashboard} allowedRoles={['Admin', 'SystemAdmin']} />
          <PrivateRoute path="/bom-approval/:assemblyId" component={BOMApprovalWrapper} />
          <PrivateRoute path="/assembly-results/:assemblyId" component={AssemblyResultsWrapper} />
          <PrivateRoute path="/training" component={TrainingDocs} />

          <Route component={NotFoundPage} />
        </Switch>
      </Layout>
    </Switch>
  </BrowserRouter>
);

